import { CountryResource } from '@models/resources/country.model';
import { CultureResource } from '@models/resources/culture.model';
import { CurrencyResource } from '@models/resources/currency.model';
import { GenderResource } from '@models/resources/gender.model';
import { PaymentMethodResource } from '@models/resources/payment-method.model';
import { ProvinceStateResource } from '@models/resources/province-state.model';
import { SuffixResource } from '@models/resources/suffix.model';
import { TimeZoneResource } from '@models/resources/time-zones.model';
import { TitleResource } from '@models/resources/title.model';
import { createAction, props } from '@ngrx/store';

export const enum ResourceActionTypes {
  getStations = '[resource] GET_STATIONS',
  setStations = '[resource] SET_STATIONS',
  getCarriers = '[resource] GET_CARRIERS',
  setCarriers = '[resource] SET_CARRIERS',
  getFormResources = '[resource] GET_FORM_RESOURCES',
  getFormResourcesSuccess = '[resource] GET_FORM_RESOURCES_SUCCESS',

  getGenderResources = '[resource] GET_GENDERS',
  getCountryResources = '[resource] GET_COUNTRIES',
  getSuffixResources = '[resource] GET_SUFFIXES',
  getPaymentMethodResources = '[resource] GET_PAYMENT_METHODS',
  getTitleResources = '[resource] GET_TITLES',
  getCurrencyResources = '[resource] GET_CURRENCIES',
  getCultureResources = '[resource] GET_CULTURES',
  getProvinceStatesResources = '[resource] GET_PROVINCE_STATES',
  getTimeZoneResources = '[resource] GET_TIME_ZONES',

  getGenderResourcesSuccess = '[resource] GET_GENDERS_SUCCESS',
  getCountryResourcesSuccess = '[resource] GET_COUNTRIES_SUCCESS',
  getSuffixResourcesSuccess = '[resource] GET_SUFFIXES_SUCCESS',
  getPaymentMethodResourcesSuccess = '[resource] GET_PAYMENT_METHODS_SUCCESS',
  getTitleResourcesSuccess = '[resource] GET_TITLES_SUCCESS',
  getCurrencyResourcesSuccess = '[resource] GET_CURRENCIES_SUCCESS',
  getCultureResourcesSuccess = '[resource] GET_CULTURES_SUCCESS',
  getProvinceStatesResourcesSuccess = '[resource] GET_PROVINCE_STATES_SUCCESS',
  getTimeZoneResourcesSuccess = '[resource] GET_TIME_ZONES_SUCCESS',
}

export const resourceGetStations = createAction(
  ResourceActionTypes.getStations,
);

export const resourceSetStations = createAction(
  ResourceActionTypes.setStations,
  props<{ loading: boolean }>(),
);

export const resourceGetCarriers = createAction(
  ResourceActionTypes.getCarriers,
);

export const resourceSetCarriers = createAction(
  ResourceActionTypes.setCarriers,
  props<{ loading: boolean }>(),
);

export const resourceGetAllResources = createAction(
  ResourceActionTypes.getFormResources,
);

export const resourceGetAllResourcesSuccess = createAction(
  ResourceActionTypes.getFormResourcesSuccess,
  props<{
    genders: GenderResource[];
    suffixes: SuffixResource[];
    countries: CountryResource[];
    paymentMethods: PaymentMethodResource[];
    titles: TitleResource[];
    currencies: CurrencyResource[];
    cultures: CultureResource[];
    provinceStates: ProvinceStateResource[];
    timeZones: TimeZoneResource[];
  }>(),
);

export const resourceGetGenders = createAction(
  ResourceActionTypes.getGenderResources,
);

export const resourceGetSuffixes = createAction(
  ResourceActionTypes.getSuffixResources,
);

export const resourceGetCountries = createAction(
  ResourceActionTypes.getCountryResources,
);

export const resourceGetPaymentMethods = createAction(
  ResourceActionTypes.getPaymentMethodResources,
);

export const resourceGetTitles = createAction(
  ResourceActionTypes.getTitleResources,
);

export const resourceGetCurrencies = createAction(
  ResourceActionTypes.getCurrencyResources,
);

export const resourceGetCultures = createAction(
  ResourceActionTypes.getCultureResources,
);

export const resourceGetTimeZones = createAction(
  ResourceActionTypes.getTimeZoneResources,
);

export const resourceGetProvinceStates = createAction(
  ResourceActionTypes.getProvinceStatesResources,
);

export const resourceGetGendersSuccess = createAction(
  ResourceActionTypes.getGenderResourcesSuccess,
  props<{
    genders: GenderResource[];
  }>(),
);

export const resourceGetSuffixesSuccess = createAction(
  ResourceActionTypes.getSuffixResourcesSuccess,
  props<{
    suffixes: SuffixResource[];
  }>(),
);

export const resourceGetCountriesSuccess = createAction(
  ResourceActionTypes.getCountryResourcesSuccess,
  props<{
    countries: CountryResource[];
  }>(),
);

export const resourceGetPaymentMethodsSuccess = createAction(
  ResourceActionTypes.getPaymentMethodResourcesSuccess,
  props<{
    paymentMethods: PaymentMethodResource[];
  }>(),
);

export const resourceGetTitlesSuccess = createAction(
  ResourceActionTypes.getTitleResourcesSuccess,
  props<{
    titles: TitleResource[];
  }>(),
);

export const resourceGetCurrenciesSuccess = createAction(
  ResourceActionTypes.getCurrencyResourcesSuccess,
  props<{
    currencies: CurrencyResource[];
  }>(),
);

export const resourceGetCulturesSuccess = createAction(
  ResourceActionTypes.getCultureResourcesSuccess,
  props<{
    cultures: CultureResource[];
  }>(),
);

export const resourceGetProvinceStatesSuccess = createAction(
  ResourceActionTypes.getProvinceStatesResourcesSuccess,
  props<{
    provinceStates: ProvinceStateResource[];
  }>(),
);

export const resourceGetTimeZonesSuccess = createAction(
  ResourceActionTypes.getTimeZoneResourcesSuccess,
  props<{
    timeZones: TimeZoneResource[];
  }>(),
);
